import Vue from "vue";

export const LeadEventBus = new Vue();
